import { render } from "./TopSectionCollapse.vue?vue&type=template&id=48018810&scoped=true"
import script from "./TopSectionCollapse.vue?vue&type=script&lang=js"
export * from "./TopSectionCollapse.vue?vue&type=script&lang=js"

import "./TopSectionCollapse.vue?vue&type=style&index=0&id=48018810&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4207129294/src/github.com/Tippie-de/frontend-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48018810"]])

export default __exports__